import React from 'react';
import { LucideIcon } from 'lucide-react';

interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  error?: string;
  icon?: LucideIcon;
  iconPosition?: 'left' | 'right';
  variant?: 'default' | 'search';
}

const Input: React.FC<InputProps> = ({
  label,
  error,
  icon: Icon,
  iconPosition = 'left',
  variant = 'default',
  className = '',
  ...props
}) => {
  const baseClasses = 'w-full bg-gray-100 border-0 rounded-2xl focus:outline-none focus:ring-2 focus:ring-gray-300 focus:bg-gray-50 transition-all duration-200 placeholder-gray-500 text-gray-800';
  
  const variantClasses = {
    default: 'px-4 py-3',
    search: 'px-4 py-3'
  };

  const iconPadding = {
    left: Icon ? 'pl-12' : '',
    right: Icon ? 'pr-12' : ''
  };

  const inputClasses = `${baseClasses} ${variantClasses[variant]} ${iconPadding[iconPosition]} ${className}`;

  return (
    <div className="w-full">
      {label && (
        <label className="block text-sm font-medium text-gray-700 mb-2">
          {label}
        </label>
      )}
      
      <div className="relative">
        {Icon && iconPosition === 'left' && (
          <Icon 
            size={20} 
            className="absolute left-4 top-1/2 transform -translate-y-1/2 text-gray-400" 
          />
        )}
        
        <input
          className={inputClasses}
          {...props}
        />
        
        {Icon && iconPosition === 'right' && (
          <Icon 
            size={20} 
            className="absolute right-4 top-1/2 transform -translate-y-1/2 text-gray-400" 
          />
        )}
      </div>
      
      {error && (
        <p className="mt-1 text-sm text-red-600">{error}</p>
      )}
    </div>
  );
};

export default Input;

